import React from 'react';
import "./TextArea.css";
import BodySmallRegular from './BodySmallRegular';
import { CircleAlert } from 'lucide-react';

const Textarea = ({
    error,
    value,
    onChange,
    disabled = false,
    placeholder = '',
    label,
    name,
    width,
    height
}) => {
    const containerStyle = width ? { width: width } : {};
    const textareaStyle = height ? { height: height } : {};

    return (
        <div className="textarea-container" style={containerStyle}>
            {label && label.length !== 0 && (
                  <p className="label-text">{label}</p>
            )}
            <div className={`textarea-main ${disabled ? 'textarea-disabled' : ''}`} style={textareaStyle}>
                <textarea
                    className="textarea-field"
                    disabled={disabled}
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    rows={4}
                    name={name}
                    // style={{width: width || "452px"}}
                />
            </div>
            {error && error.trim().length > 0 && (
                <div className="error-text-container">
                    <CircleAlert height={16} />
                    <span className="error-text">{error}</span>
                </div>
            )}
        </div>
    );
};

export default Textarea;